
import React from 'react';
import { SystemBotStatus } from './SystemBotStatus';

export function TelegramTokenManager() {
  return (
    <div className="space-y-8">
      <SystemBotStatus />
    </div>
  );
}
